import * as React from "react"
import { SVGProps } from "react"

const Key = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={28}
    height={28}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.613 16.916a1.167 1.167 0 0 0-1.01-.583H6.317L3.983 14l2.332-2.334h6.288c.417 0 .802-.222 1.01-.582a5.833 5.833 0 1 1 0 5.832Z"
      stroke="#9DA3B7"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.833 14a1.167 1.167 0 1 1-2.333 0 1.167 1.167 0 0 1 2.333 0Z"
      stroke="#9DA3B7"
      strokeWidth={2}
    />
  </svg>
)

export default Key
